var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3908 17.0378C9.11426 19.4257 3.73047 17.9412 1.37613 13.7249C-0.978206 9.50853 0.582497 4.14634 4.85907 1.75837C9.13564 -0.629597 14.5194 0.854902 16.8738 5.07125C19.2281 9.28759 17.6674 14.6498 13.3908 17.0378Z","fill":"#281830"}));
}

Circle.defaultProps = {"width":"18","height":"19","viewBox":"0 0 18 19","fill":"none"};

module.exports = Circle;

Circle.default = Circle;
